import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoggerService } from 'src/app/telemetry/logger.service';
import { CompleteBinaryDataDto } from '../../models/dtos/complete-binary-data.dto';
import { DispatchedServiceSyncDataDto } from '../../models/dtos/dispatched-service-sync-data.dto';

/**
 * Service used to send binary data fragment sync data
 */
@Injectable({
	providedIn: 'root'
})
export class BinaryDataFragmentSyncDataDataService {

	/*
	* The name of the HTTP header for the complete binary data sync message.
	*/
	public static readonly COMPLETE_BINARY_DATA_SYNC_HEADER_NAME: string = "crown-x-complete-binary-data-sync";

	/*
	* The path to the binary data fragment sync controller.
	*/
	private static readonly CONTROLLER_PATH: string = "/api/BinaryDataFragmentSyncData";

	/**
	 * @constructor
	 *
	 * @param httpClient The HTTP client to use for web requests.
	 * @param logger The logging service.
	 */
	constructor(
		private readonly httpClient: HttpClient,
		private readonly logger: LoggerService
	) { }

	/**
	 * Saves binary data fragment sync data for a service for the current driver
	 * @param service The binary data fragment sync data for a service to send
	 * @returns An observable to indicate when the process is done
	 */
	public Save$(service: DispatchedServiceSyncDataDto): Observable<void> {
		try {
			const url: string = `${BinaryDataFragmentSyncDataDataService.CONTROLLER_PATH}/save-binary-data-fragment`
			return this.httpClient.post<void>(url, service, { withCredentials: true });
		}
		catch (error: any) {
			this.logger.TrackError("Failed to send the binary data fragment for saving binary data fragments.", error);
			return throwError(() => error);
		}
	}

	/**
	 * Notifies the server that the final binary data fragment has been synced, indicating that the binary data sync process is complete.
	 * @param binaryData The binary data for the complete binary data object being completed.
	 * @returns An observable that emits when the notification has been successfully sent to the server and completes.
	 */
	public TriggerBinaryDataFragmentSyncComplete$(binaryData: CompleteBinaryDataDto): Observable<void> {
		let syncHeaders: HttpHeaders = new HttpHeaders();
		syncHeaders = syncHeaders.append(BinaryDataFragmentSyncDataDataService.COMPLETE_BINARY_DATA_SYNC_HEADER_NAME, binaryData.LegacyId.toString());
		try {
			const url: string = `${BinaryDataFragmentSyncDataDataService.CONTROLLER_PATH}/complete-binary-data-sync`
			return this.httpClient.post<void>(url, binaryData, { withCredentials: true, headers: syncHeaders });
		}
		catch (error: any) {
			this.logger.TrackError("Failed to send binary data information for completing binary data sync cycle.", error);
			return throwError(() => error);
		}
	}
}
